module.exports = __webpack_public_path__ + "img/linkedin.b286b20d.png";